export const getBooleanValue = (value?: boolean): boolean => (typeof value === 'boolean' ? value : false);
